import styled from "styled-components";

export const Content = styled.td`
    padding: 6px;
    font-weight: 500;
`;